import {
  deleteEmail,
  deleteMailingList,
  getEmailsForMailingList,
  updateAllContactFieldsForMailingListAudience,
  updateMailingListName,
  getUserMailingListsForSignUpForms,
  markInvalidEmailAsValid,
} from '@Components/email-marketing-campaign-audience/email-marketing-campaign-audience-thunk';
import type {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import type {AudienceMapDataPayload, AudienceState} from '@Components/email-marketing-campaign-audience/email-marketing-campaign-audience-reducer';
import {
  doUpdateSignupFormMailingLists,
  doUpdateAudienceDataForMailingListAudience,
  addAudience,
  addAudienceIdsToMailingList,
  addMailingList,
  changeMailingListName,
  markAudienceAsValid,
  removeAudience,
  removeMailingList,
} from '@Components/email-marketing-campaign-audience/email-marketing-campaign-audience-reducer';
import {getEmailStatesEnumValues} from '@Libraries/email-marketing-campaigns-audience-library';
import type {AudienceMailingList} from '@Components/mailing-list-wizard/mailing-list-wizard.types';

export const emailMarketingCampaignAudienceExtraReducers = (builder: ActionReducerMapBuilder<AudienceState>): void => {
  builder.addCase(getEmailsForMailingList.fulfilled, (state, {payload}) => {
    const audienceIds: number[] = [];
    payload.audiences.forEach((item) => {
      addAudience(state, item);
      audienceIds.push(item.id);
    });

    if (!state.mailingLists[payload.idMailingList]) {
      const getEmailsForMailingListParams: AudienceMailingList = {
        emailIds: audienceIds,
        id: payload.idMailingList,
        name: payload.name,
        totalEmailsCount: payload.count,
        filters: getEmailStatesEnumValues().reduce((obj, emailState) => {
          return {...obj, [emailState]: true};
        }, {}),
        searchTerm: '',
        isSpam: payload.isSpam,
        lastViewed: payload.lastViewed,
        isSmart: payload.isSmart,
        isSharedInTeam: payload.isSharedInTeam,
        idOwner: payload.idOwner,
      };

      addMailingList(state, payload.idMailingList, getEmailsForMailingListParams);
    } else {
      addAudienceIdsToMailingList(state, payload.idMailingList, audienceIds);
    }
  });

  builder.addCase(deleteEmail.fulfilled, (state, {meta}) => {
    const {audience, idMailingList, index} = meta.arg;
    const idAudience = audience.id;

    removeAudience(state, idMailingList, idAudience, index);
  });

  builder.addCase(markInvalidEmailAsValid.fulfilled, (state, {meta, payload}) => {
    if (payload.numListsUpdated <= 0) {
      return;
    }

    markAudienceAsValid(state, meta.arg.audience.id);
  });

  builder.addCase(updateMailingListName.pending, (state, {meta}) => {
    const {idMailingList, newName} = meta.arg;
    changeMailingListName(state, idMailingList, newName);
  });

  builder.addCase(updateMailingListName.rejected, (state, {meta}) => {
    const {idMailingList, currentName} = meta.arg;
    changeMailingListName(state, idMailingList, currentName);
  });

  builder.addCase(deleteMailingList.fulfilled, (state, {meta}) => {
    const {idMailingList} = meta.arg;
    removeMailingList(state, idMailingList);
  });

  builder.addCase(updateAllContactFieldsForMailingListAudience.fulfilled, (state, {meta}) => {
    const {arg} = meta;
    doUpdateAudienceDataForMailingListAudience(state, arg as AudienceMapDataPayload);
  });
  
  builder.addCase(getUserMailingListsForSignUpForms.fulfilled, (state, {payload}) => {
    doUpdateSignupFormMailingLists(state, payload.mailingLists);
  });

  builder.addCase(getUserMailingListsForSignUpForms.rejected, (state) => {
    doUpdateSignupFormMailingLists(state, []);
  });
};
